// extracted by mini-css-extract-plugin
export var autoExpand = "_1w-8";
export var container = "_1w-7";
export var containerWidth = "_1w-5";
export var disabled = "_1w-2";
export var error = "_1w-3";
export var fullWidth = "_1w-6";
export var inputWrapper = "_1w-0";
export var small = "_1w-1";
export var textarea = "_1w-4";